import { render, staticRenderFns } from "./MyFavorites.vue?vue&type=template&id=fba5d4ec&scoped=true"
import script from "./MyFavorites.vue?vue&type=script&lang=js"
export * from "./MyFavorites.vue?vue&type=script&lang=js"
import style0 from "./MyFavorites.vue?vue&type=style&index=0&id=fba5d4ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba5d4ec",
  null
  
)

export default component.exports